import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useAtom } from 'jotai';
import {
  Dialog,
  DialogActions,
  Slide,
  DialogContent,
  Button,
  Typography,
  Box,
} from '@mui/material';
import CheckCircleOutlineSharpIcon from '@mui/icons-material/CheckCircleOutlineSharp';
import ErrorOutlineSharpIcon from '@mui/icons-material/ErrorOutlineSharp';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import WarningAmberSharpIcon from '@mui/icons-material/WarningAmberSharp';
import { alertDialogAtom } from '../../Atoms';

const getDialogProps = (intl, data) => {
  const { title = '', severity = 'info' } = data;
  if (severity === 'success')
    return {
      IconComponent: CheckCircleOutlineSharpIcon,
      title: title || intl.messages.SUCCESS,
      color: '#00796B',
    };
  if (severity === 'warning')
    return {
      IconComponent: WarningAmberSharpIcon,
      title: title || intl.messages.WARNING,
      color: '#FF8C00',
    };
  if (severity === 'error')
    return {
      IconComponent: ErrorOutlineSharpIcon,
      title: title || intl.messages.ERROR,
      color: '#B00020',
    };
  return {
    IconComponent: InfoOutlinedIcon,
    title: title || intl.messages.INFO,
    color: '#ccc',
  };
};
const AlertDialog = function AlertDialog() {
  const intl = useIntl();
  const [open, setOpen] = useAtom(alertDialogAtom); //Object. handles Dialog's opening and closing state and contains props.
  const [{ IconComponent = InfoOutlinedIcon, ...lastSaved }, setLastSaved] =
    useState({}); //Object. Contains Dialog's props saved on open.
  useEffect(() => {
    if (open) {
      //saves data on open dialog
      setLastSaved({
        ...getDialogProps(intl, open),
        message: open?.message || '',
      });
    }
  }, [open]);
  //handleClose fired only when onClose is triggered (ex: onClick Close btn)
  const handleClose = () => {
    setOpen(null);
  };
  return (
    <Dialog
      slots={{ transition: Slide }}
      transitionDuration={400}
      slotProps={{ transition: { direction: 'up' } }}
      fullWidth
      maxWidth="sm"
      open={Boolean(open)}
      onClose={(_, reason) => {
        if (reason !== 'backdropClick') {
          handleClose();
        }
      }}
    >
      <DialogContent
        sx={{
          display: 'flex',
          flexDirection: 'column',
          padding: 'unset',
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "16px",
            backgroundColor: lastSaved?.color,
            color: "#fff",
            width: "100%",
            padding: "30px"
          }}>
          <IconComponent sx={{ fontSize: '60px', color: 'inherit' }} />
          <Typography
            variant="button"
            sx={{
              color: "inherit",
              fontSize: "18px",
              letterSpacing: "0.1em"
            }}>
            {lastSaved?.title}
          </Typography>
        </Box>
        <Box
          sx={{
            width: "100%",
            padding: "20px",
            display: "flex",
            justifyContent: "center"
          }}>
          <Typography
            variant="subtitle1"
            sx={{
              color: "inherit",
              textAlign: "center"
            }}>
            {lastSaved?.message}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={handleClose}>
          {intl.messages.CLOSE}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default AlertDialog;
